import { render, staticRenderFns } from "./contrastive-analysis.vue?vue&type=template&id=bf6ef334&scoped=true&"
import script from "./contrastive-analysis.vue?vue&type=script&lang=js&"
export * from "./contrastive-analysis.vue?vue&type=script&lang=js&"
import style0 from "./contrastive-analysis.vue?vue&type=style&index=0&id=bf6ef334&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6ef334",
  null
  
)

export default component.exports